import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

// reactstrap components
import { Button, FormGroup, Input, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import InputPDF from "components/Input/InputPDF";


// services
import { showMessage, } from "../../../services/message.js";
import { api_POST } from "../../../services/api_service.js";
import { formateDateApi } from "../../../helpers/formats";

//Context
import { useAuth } from '../../../context/auth';

export default function ConfirmacaoVistoria({ requerimentoTransportadorAgendamento_Id, placa, handleReturn }) {
    const {session, setLoading} = useAuth();

    const { register, getValues } = useForm({ mode: "onBlur" });

    const [modal, setModal] = React.useState(false);
    const toggleModal = () => {
        setModal(!modal);
        handleReturn(false);
    }

    useEffect(() => {
        setModal(true);
    }, [requerimentoTransportadorAgendamento_Id]);

    // Arquivo Renavam
    const [file_laudo, set_file_laudo] = React.useState(null);
    const handleFileLaudo = (_file, callback) => {
        if (_file == null) {
            showMessage("Aviso", "Selecione o arquivo para importação.", 'error', null);
            return;
        }
        set_file_laudo(_file);
        callback();
    }

    const handleClickAprovacao = (situacao) => {
        if (!file_laudo) {
            showMessage("Aviso", "Selecione o arquivo com o Laudo da Vistoria para importação.", 'error', null);
            return;
        }

        let data = getValues();

        let json_submit = {
            requerimentoTransportadorVistoria_Id: 0,
            requerimentoTransportadorAgendamento_Id: requerimentoTransportadorAgendamento_Id,
            dataHoraAtualizacao: formateDateApi(new Date()),
            situacao: situacao,
            observacao: data.observacao,
            arquivoLaudoVistoria: file_laudo.name,
            arquivoLaudoVistoriaBase64: file_laudo.base64,
            usuario_Id: session.usuario_Id
        }

        setLoading(true);
        api_POST(`AnaliseRequerimento/PostRequerimentoTransportadorVistoria`, json_submit)
            .then(result => {
                setLoading(false);
                showMessage("Aviso", "Operação realizada com sucesso!", 'success', function () {
                    if (handleReturn)
                        handleReturn(true);
                });
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    return (
        <Modal isOpen={modal} toggle={toggleModal}>
            <ModalHeader toggle={toggleModal} close={<button className="close" onClick={toggleModal}>&times;</button>} className="md-hd">
                <i class="fas fa-file-alt"></i>  Confirmação de Vistoria
            </ModalHeader>
            <ModalBody className="md-bd">
                <Row>
                    <Col lg="12" md="12" sm="12">
                        <FormGroup>
                            <b><label>Veículo</label> </b>
                            <Input type="text" readonly="readonly" name="placa" defaultValue={placa}></Input>
                        </FormGroup>
                    </Col>
                    <Col lg="12" md="12" sm="12">
                        <FormGroup>
                            <b><label>Observação</label> </b>
                            <Input type="text" name="observacao" innerRef={register()}></Input>
                        </FormGroup>
                    </Col>
                    <Col lg="12" md="12" sm="12">
                        <FormGroup>
                            <b><p style={{ color: "#888" }}>Laudo da Vistoria</p></b>
                            <InputPDF name="arquivoRenavam"
                                image={file_laudo}
                                height="3rem"
                                width="3rem"
                                documento_id={0} handlefile={handleFileLaudo}>
                            </InputPDF>
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter className="md-ft">
                <Button color="success" onClick={() => handleClickAprovacao("Aprovado")}> Aprovar Vistoria</Button>
                <Button color="danger" onClick={() => handleClickAprovacao("Reprovado")}> Reprovar Vistoria</Button>
            </ModalFooter>
        </Modal>

    );
}

